export const parsePresentationNameToWorkflowCode = (presetationName: string) => {
  return "#" + presetationName.toUpperCase().trim().replaceAll(" ", "_");
};